import { QuotaService } from "./quotaService";
export { QuotaStatus } from "./quotaService";

export default new QuotaService();
